import { BuffType } from '@/game/types';
import type { Translations } from '@/i18n/types';
import type { GameIconName } from '@/shared/ui/game-icon';

export const BUFF_ICON: Record<BuffType, GameIconName> = {
  [BuffType.Rush]: 'zap', [BuffType.Rage]: 'swords', [BuffType.Shield]: 'shield',
  [BuffType.Luck]: 'clover', [BuffType.Resurrection]: 'sparkles', [BuffType.Heal]: 'heart',
  [BuffType.PowerPotion]: 'flask', [BuffType.WarCry]: 'megaphone',
};

/** Icons and colors for buff UI (labels/descriptions come from i18n like HeroPanel). */
export const BUFF_VISUAL: Record<BuffType, { icon: string; color: string }> = {
  [BuffType.Rush]: { icon: '\u26A1', color: '#8db6c7' },
  [BuffType.Rage]: { icon: '\u2694\uFE0F', color: '#d08470' },
  [BuffType.Shield]: { icon: '\uD83D\uDEE1\uFE0F', color: '#a5b4d1' },
  [BuffType.Luck]: { icon: '\uD83C\uDF40', color: '#9dbb81' },
  [BuffType.Resurrection]: { icon: '\uD83D\uDD2E', color: '#c8a1cb' },
  [BuffType.Heal]: { icon: '\u2764\uFE0F', color: '#d58d95' },
  [BuffType.PowerPotion]: { icon: '\uD83E\uDDEA', color: '#b69bcc' },
  [BuffType.WarCry]: { icon: '\uD83D\uDCE3', color: '#d4b370' },
};

export function buffUiStrings(tr: Translations, type: BuffType): { label: string; desc: string } {
  const keys: Record<BuffType, [keyof Translations, keyof Translations]> = {
    [BuffType.Rush]: ['buffRush', 'buffRushDesc'],
    [BuffType.Rage]: ['buffRage', 'buffRageDesc'],
    [BuffType.Shield]: ['buffShield', 'buffShieldDesc'],
    [BuffType.Luck]: ['buffLuck', 'buffLuckDesc'],
    [BuffType.Resurrection]: ['buffResurrection', 'buffResurrectionDesc'],
    [BuffType.Heal]: ['buffHeal', 'buffHealDesc'],
    [BuffType.PowerPotion]: ['buffPowerPotion', 'buffPowerPotionDesc'],
    [BuffType.WarCry]: ['buffWarCry', 'buffWarCryDesc'],
  };
  const [lk, dk] = keys[type];
  return { label: tr[lk], desc: tr[dk] };
}
